import { Component, computed, effect, inject, linkedSignal, signal } from '@angular/core';
import { Location } from 'node_modules/@angular/common';
import { Business, BusinessBranch, License, toWithFormattedAddress, WithFormattedAddress } from 'src/model/business';
import { FinanceAccount } from 'src/model/financeAccount.model';
import { BusinessService } from 'src/services/business.service';
import { FinanceAccountService } from 'src/services/finance-account.service';
import { getBankLogoByName } from '../bank.config';
import { BusinessStore } from 'src/model/business/business-store';

@Component({
	selector: 'app-bank-redemption-letter',
	standalone: false,
	templateUrl: './bank-redemption-letter.component.html',
	styleUrl: './bank-redemption-letter.component.scss'
})
export class BankRedemptionLetterComponent {
	private location = inject(Location);
	private businessService = inject(BusinessService);
	private faService = inject(FinanceAccountService);
	private businessStore = inject(BusinessStore);

	readonly today = new Date();
	oriAmount = signal<number>(0);
	oriLicenseId = signal<number>(-1);

	customerName = signal<string>('');
	customerIc = signal<string>('');
	amount = signal<number>(0);
	licenseId = signal<number>(-1);
	headerBusinessId = signal<number>(-1);
  businessId = linkedSignal<number>(() => this.headerBusinessId());

	licenseList = signal<License[]>([]);
	branchList = signal<BusinessBranch[]>([]);
	faList = signal<FinanceAccount[]>([]);

	businessList = this.businessStore.businessList;
	licenseBusinessMap = this.businessStore.licenseBusinessIdMap;

	businessLicenseList = computed<WithFormattedAddress<License>[]>(() =>
		this.licenseList()
			.filter(l => l.BusinessId === this.headerBusinessId())
			.map(toWithFormattedAddress)
	);
	businessFaList = computed<FinanceAccount[]>(() => {
		const businessId = this.businessId();
		return businessId < 0 ? [] : this.faList().filter(fa => fa.BusinessIds.includes(businessId));
	});

	license = signal<WithFormattedAddress<License>>(undefined);
	headerBusiness = computed<Business>(() => {
		const id = this.headerBusinessId();
		return id > -1 ? this.businessList().find(b => b.Id == id) : undefined;
	});
  business = computed<Business>(() => {
		const id = this.businessId();
		return id > -1 ? this.businessList().find(b => b.Id == id) : undefined;
	});
	financeAccount = signal<FinanceAccount>(undefined);

	getBankLogoByName = getBankLogoByName;

	constructor() {
		effect(() => {
			const licenseId = this.licenseId();
			this.headerBusinessId.set(this.licenseBusinessMap().get(licenseId));
		});

		effect(() => {
			const businessFaList = this.businessFaList();
			this.financeAccount.set(businessFaList.length > 0 ? businessFaList[0] : undefined);
		});

		effect(() => {
			const businessLicenseList = this.businessLicenseList();
			this.license.set(businessLicenseList.length > 0 ? businessLicenseList[0] : undefined);
		});
	}

	ngOnInit(): void {
		const state = this.location.getState() as any;
		if (state && state.customerName) {
			this.getData();
			this.oriAmount.set(state.settlement);
			this.amount.set(state.settlement);
			this.customerName.set(state.customerName);
			this.customerIc.set(state.customerIc);
			this.oriLicenseId.set(state.licenseId);
			this.licenseId.set(state.licenseId);
		} else {
			this.location.back();
		}
	}

	async getData() {
		const [licenses, branches, businesses, faList] = await Promise.all([
			this.businessService.getAllLicenses(),
			this.businessService.getAllBusinessBranches(),
			this.businessService.getAllBusinesses(),
			this.faService.getAllFinanceAccounts()
		]);
		this.licenseList.set(licenses);
		this.branchList.set(branches);
		this.businessList.set(businesses);
		this.faList.set(faList);
	}

	reset() {
		this.licenseId.set(this.oriLicenseId());
		this.headerBusinessId.set(-1);
		this.amount.set(this.oriAmount());
	}

	print() {
		window.print();
	}
}
